import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
export const LoadingSpinner = ({ message = 'Carregando...', size = 'medium' }) => {
    const sizeMap = {
        small: '20px',
        medium: '40px',
        large: '60px',
    };
    return (_jsxs("div", { style: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            gap: '1rem',
        }, children: [_jsx("div", { style: {
                    width: sizeMap[size],
                    height: sizeMap[size],
                    border: '3px solid #f3f3f3',
                    borderTop: '3px solid #3498db',
                    borderRadius: '50%',
                    animation: 'spin 1s linear infinite',
                } }), _jsx("div", { style: { color: '#666', fontSize: '14px' }, children: message }), _jsx("style", { children: `
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      ` })] }));
};
